<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.cutting.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.cutting.machines.machine' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.cutting.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.name.label' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.divisionType.name' | translate }}</mat-label>
			<mat-select formControlName="divisionType">
				<mat-option [value]="'BetweenEveryOptimizationGroup'">{{ 'masterdata.cutting.divisionType.betweenEveryOptimizationGroup' | translate }}</mat-option>
				<mat-option [value]="'BetweenEveryMaterial'">{{ 'masterdata.cutting.divisionType.betweenEveryMaterial' | translate }}</mat-option>
				<mat-option [value]="'BetweenEveryRule'">{{ 'masterdata.cutting.divisionType.betweenEveryRule' | translate }}</mat-option>
				<mat-option [value]="'Never'">{{ 'masterdata.cutting.divisionType.never' | translate }}</mat-option>
			</mat-select>
		</mat-form-field>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.cutting.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.cutting.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
